export const setLanguage = language => {
  let lng = language.toLowerCase();
  try {
    localStorage.setItem("lng", lng);
  } catch (e) {}

  return {
    type: "SET_LANGUAGE",
    language
  };
};

export const setCurrentNavPage = currentNavPage => {
  return {
    type: "SET_CURRENT_NAV_PAGE",
    currentNavPage
  };
};

export const pushSourceToken = (sourceName, sourceToken) => {
  return {
    type: "PUSH_SOURCE_TOKEN",
    sourceName,
    sourceToken
  };
};

export const clearSourcesTokens = () => {
  return {
    type: "CLEAR_SOURCES_TOKENS"
  };
};

export const setTTPDialogShow = showDialog => {
  return {
    type: "SET_TTP_Dialog_SHOW",
    showDialog
  };
};

export const setTTPDialogCustomData = customData => {
  return {
    type: "SET_TTP_Dialog_CUSTOM_DATA",
    customData
  };
};

export const setSubMenuDirection = subMenuDirection => ({
  type: "SET_SUB_MENU_DIRECTION",
  subMenuDirection
});

export const setApplication = application => ({
  type: "SET_APPLICATION",
  application
});



// WEBPACK FOOTER //
// ./app/actions/actions/params.js